export const getPriceDifferential = (price1, price2) => {
  if (price1 && price2) {
    let priceA = price1.replace('$', '').replace(/,/g, '') || 0;
    let priceB = price2.replace('$', '').replace(/,/g, '') || 0;
    // console.log({priceA, priceB})
    const result = priceA - priceB;
    return '$' + String(result).replace(/(.)(?=(\d{3})+$)/g, '$1,');
  }
  return '';
};
